import Vue, { PluginFunction, PluginObject } from 'vue';
import VueRouter from 'vue-router';

declare module 'vue/types/vue' {
  interface Vue {
    $enum: GlobalEnum;
  }
}
interface keyVal {
  key: string | number;
  val: string;
}
export class GlobalEnum extends Vue {
  // 頁數
	public pageEnum: { key: string; page: string }[] = [
		{ key: 'A', page: '10' },
		{ key: 'B', page: '25' },
		{ key: 'C', page: '50' },
	];
	
	// ---------------------func-------------------------------
	public getKey(objName, index) {
		if (this[objName].find((i) => i.val === index)) {
			return this[objName].find((i) => i.val === index).key;
		}
		return '';
	}

	public getVal(objName, index) {
		if (this[objName].find((i) => i.key === index)) {
			return this[objName].find((i) => i.key === index).val;
		}
		return '';
	}

	public install(Vue) {
		Vue.prototype.$enum = this;
	}
}
export default new GlobalEnum();
